/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2018.8.31
 */
import '@/plugins/velocity/L.VelocityLayer';
/**
 * 
 */
export default (data,options) => L.velocityLayer(T.assign({
  displayValues: true,
  displayOptions: {
    velocityType: 'GBR Wind',
    displayPosition: 'bottomleft',
    displayEmptyString: 'No wind data'
    // velocityType: 'Global Wind',
    // position: 'bottomleft',
    // emptyString: 'No velocity data',
    // angleConvention: 'bearingCW',
    // displayPosition: 'bottomleft',
    // displayEmptyString: 'No velocity data',
    // speedUnit: 'kt'
  },
  data: data,                //grib2.json
  // OPTIONAL
  // minVelocity: 0,          // used to align color scale
  // maxVelocity: 10,         // used to align color scale
  // velocityScale: 0.005,    // modifier for particle animations, arbitrarily defaults to 0.005
  // colorScale: []           // define your own array of hex/rgb colors
  maxVelocity: 10
}, options));



// WEBPACK FOOTER //
// ./src/plugins/velocityLayer.js